import { Request } from "@/types/request";

const getTrimmedText = (value?: string | null) => {
  const trimmedValue = value?.trim();
  return trimmedValue ? trimmedValue : null;
};

export const getRequestDisplayTitle = (
  request: Pick<Request, "service" | "description" | "notes">,
  noServiceLabel: string,
) => {
  return (
    request.service?.name ||
    getTrimmedText(request.description) ||
    getTrimmedText(request.notes) ||
    noServiceLabel
  );
};
